module.exports = __webpack_public_path__ + "static/media/alpi-desktop-screens.275ecc1c.png";